import React from "react";
import PropTypes from "prop-types";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const PORTAL_ID = "app-datepicker-portal";

// "YYYY-MM-DD" <-> local Date (new Date("YYYY-MM-DD") would parse as UTC and can land on the previous day)
const toDate = (value) => {
  if (!value) return null;
  const [year, month, day] = value.split("-").map(Number);
  return new Date(year, month - 1, day);
};

const pad = (number) => String(number).padStart(2, "0");

const toValue = (date) =>
  date
    ? `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())}`
    : "";

/**
 * Date field for filters. Unlike the browser's native date popup (which cannot be repositioned and gets cut off
 * near the edge of a narrow window), the calendar renders into the page body and flips / shifts to stay on screen.
 *
 * @param {Object} props
 * @param {string} props.value - "YYYY-MM-DD" or ""
 * @param {(value: string) => void} props.onChange - called with "YYYY-MM-DD" or "" when cleared
 * @param {string} [props.min] - "YYYY-MM-DD", earliest selectable date
 */
const DateFilterInput = ({ id, value, onChange, min, placeholder, style }) => (
  <DatePicker
    id={id}
    selected={toDate(value)}
    onChange={(date) => onChange(toValue(date))}
    minDate={toDate(min) || undefined}
    dateFormat="MM/dd/yyyy"
    placeholderText={placeholder}
    portalId={PORTAL_ID}
    popperPlacement="bottom-start"
    isClearable
    autoComplete="off"
    className="form-control date-filter-input"
    wrapperClassName="date-filter-wrapper"
    customInputRef="ref"
    {...(style ? { style } : {})}
  />
);

DateFilterInput.propTypes = {
  id: PropTypes.string,
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.string,
  placeholder: PropTypes.string,
  style: PropTypes.object,
};

export default DateFilterInput;
